// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"78e7e54b","990":"8b2a6da4"}[chunkId] + ".chunk.js";
};